
import React from 'react';
import CanvasCard from './CanvasCard';


function CanvasCardContainer(props) {
    return (<CanvasCard {...props} />);
}

export default CanvasCardContainer;